<template>
  <div>
    <a-card :title="$t('moduleTitles.basicSetting')" :bordered="false">
      <div class="basic-box">
        <div class="box-left">
          <div style="text-align: center">
            <div class="avatar">
              <img :src="form.thumb_path" width="100%" height="100%" alt="avatar" />
            </div>
            <div class="avatar-btn">
              <material-select :type="1" @selected="handleSelectedLandmark">
                <template slot="body">
                  <a-button type="primary">
                    {{ $t("actionTitles.changeCover") }}
                  </a-button>
                </template>
              </material-select>
              <div class="tips">
                {{ $t("descriptions.recommendSize") }}<br />450 x 450
              </div>
            </div>
          </div>
        </div>
        <div class="box-right">
          <a-form-model layout="vertical" ref="ruleForm" :form="form" :rules="rules" :model="form">
            <a-form-model-item has-feedback :label="$t('publish.workName.label')">
              <a-input v-model="form.name" />
            </a-form-model-item>
            <a-form-model-item has-feedback :label="$t('publish.pDescription')">
              <!-- <a-textarea
                      v-model="form.brief"
                      :placeholder="$t('publish.desPlaceholder')"
                      allow-clear
                      :rows="4"
                      class="introduction-textarea"
              /> -->
              <editor :value="form.brief" @changeEditor="changeEditor"></editor>
            </a-form-model-item>
            <div style="display: flex; justify-content:space-between;">
              <a-form-model-item has-feedback :label="$t('publish.isPublic')">
                <a-radio-group v-model="form.is_public">
                  <a-radio :value="1" >{{
                    $t("publish.public") }}</a-radio>
                  <a-radio :value="0">{{
                    $t("publish.pravite") }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item has-feedback :label="'顯示浮水印'">
                <a-radio-group v-model="form.is_water">
                  <a-radio :value="1">是</a-radio>
                  <a-radio :value="0">否</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </div>
            <a-tree-select v-model="form.cate" :replaceFields="{
              children: 'children',
              title: 'name',
              key: 'id',
              value: 'id',
            }" :tree-data="cateTree" tree-default-expand-all></a-tree-select>
            <div class="options-item">
              <a-form-item :label="$t('publish.workTag.label')">
                <CTagSelect :defaultValue="form.tag" @updateTagData="updateTagData"></CTagSelect>
              </a-form-item>
            </div>

            <div class="options-item">
              <a-form-item :label="$t('publish.workRegion.label')">
                <HRegionSelect :defaultValue="form.parent_region" @regionData="getRegionData"></HRegionSelect>
              </a-form-item>
            </div>

            <!-- <a-form-model-item has-feedback :label="$t('publish.companyName')">
              <a-select v-model="form.company" label-in-value :default-value="{ key: 0 }">
                <a-select-option value="1">成都總公司</a-select-option>
                <a-select-option value="2">南京分公司</a-select-option>
              </a-select>
            </a-form-model-item>-->
            <div class="options-item">
              <a-form-model-item :label="$t('publish.address.label')">
                <a-input :placeholder="$t('publish.address.placeholder')" v-model="form.detail_address" />
              </a-form-model-item>
            </div>
            <div class="options-item">
              <a-row>
                <a-col :span="10">
                  <a-form-model-item :label="$t('publish.customerName.label')">
                    <a-input :placeholder="$t('publish.customerName.placeholder')" v-model="form.customer_name" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                </a-col>
                <a-col :span="10">
                  <a-form-model-item :label="$t('publish.customerTel.label')">
                    <a-input :placeholder="$t('publish.customerTel.placeholder')" v-model="form.customer_phone" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>

            <a-form-model-item>
              <a-button type="primary" @click="handleSubmit">
                {{$t("actionTitles.submit")}}
              </a-button>
              <a-button style="margin-left: 10px" @click="handleCancel">
                {{$t("actionTitles.cancel")}}
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import HRegionSelect from "@/components/HRegionSelect";
import CTagSelect from "@/components/Tag";
import MaterialSelect from "@/components/MaterialSelect";
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";

import { getTree as getCateTree } from "@/api/cate";

export default {
  components: { HRegionSelect, CTagSelect, MaterialSelect, Editor },
  data() {
    return {
      form: {
        uid: null,
        name: "",
        thumb_path:
          "http://qiniu.vipyun.vip/1812/works/7510212bb95f1259/thumb.jpg",
        brief: "",
        is_public: 1,
        // 浮水印 
        // 創建作品那邊的資料是 0:有,1:無
        // 會這樣是因為 後端那邊為了舊資料的顯示 所以把創建送出的is_water+1
        // 在設定頁就要以1跟2來顯示
        // 後端搜尋 $params['is_water'] 可以找到
        is_water: 1,
        cate: null,
        tag: [],
        region: null,
        parent_region: [],
        detail_address: "",
        customer_name: "",
        customer_phone: "",
      },
      cateTree: [],
      // defaultValue: [],
      rules: {
        // phone: { required: true, message: "", trigger: "blur" },
      },
      uploadType: "normal",
    };
  },
  computed: { ...mapGetters(["vrbase", "userInfo"]) },
  created() {
    this.form = this.$deepClone(this.vrbase.base);
    console.log("this.vrbase.base =>", this.vrbase.base);
    //獲取分類
    getCateTree().then((res) => {
      this.cateTree = res.data;
    });
  },
  methods: {
    updateTagData(data) {
      this.form.tag = data;
      console.log(this.form);
    },
    handleSelectedLandmark(value) {
      this.form.thumb_path = value.url;
      console.log(value);
    },
    cateSelected(data) {
      console.log("cateSelected==", data);
      this.form.cate = data.id;
    },
    handleCancel() {
      this.form = this.$deepClone(this.vrbase.base);
    },
    handleSubmit() {
      // e.preventDefault();
      if (!this.form.name) {
        this.$message.error(this.$t("form.work.field.name.placeholder"));
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log("===result==", {
            ...this.vrbase,
            base: this.form,
          });
          const vrbase = { ...this.vrbase, base: this.form };
          this.$store
            .dispatch("saveVRBase", { vrbase, showLoading: true })
            .then(() => { });
        } else {
          console.log("表單驗證錯誤");
        }
      });
    },
    getRegionData(data) {
      this.form.region = data;
    },
    changeEditor(content) {
      this.form.brief = content;
    },
  },
};
</script>

<style lang="less" scoped>
.avatar-btn {
  display: flex;
  justify-content: space-between;
  padding: 0 5px;

  .tips {
    font-size: 12px;
    text-align: right;
  }

  .avatarBtn {
    background-color: #7101ad;
    border-color: #7101ad;
  }
}

.avatar {
  margin-bottom: 18px;
}

.avatar img {
  border-radius: 8px;
  width: 167px;
  height: 167px;
}

.options-item {
  margin: 24px 0;
}

.tag {
  display: flex;
  justify-content: space-between;
}

.tag-content {
  display: flex;
  flex-wrap: wrap;
}

.basic-box {
  display: flex;

  .box-left {
    flex-shrink: 0;
    width: 200px;
    display: flex;
    justify-content: center;
  }

  .box-right {
    width: 100%;
    padding-left: 30px;
    max-width: 600px;

    .submitBtn {
      background-color: #7101ad;
      border-color: #7101ad;
    }
  }
}

::v-deep .quill-editor {
  color: #000;
  height: 370px;
}

::v-deep .ql-container,
::v-deep .ql-editor {
  height: 300px;
}
</style>
<style lang="less">
.introduction-textarea {
  .ant-input-textarea-clear-icon {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.3);
    margin-right: 12px;

    &:hover {
      color: rgba(255, 255, 255, 0.4);
    }
  }

  .ant-input {
    padding-right: 24px;
  }

  .ant-input::-webkit-scrollbar {
    /*滾動條整體樣式*/
    width: 10px;
    /*高寬分別對應橫豎滾動條的尺寸*/
    height: 1px;
  }
}
</style>
